/******************
 Modals
 ***************/

// open the BNPL Modal
document.querySelector('#cartAsideBnpl')?.addEventListener('click', function () {
    openModal(document.querySelector('.bnpl'));
})

// Checkout click
document.querySelector("#cartAsideCheckout")?.addEventListener("click", function () {
    openModal(document.querySelector('#shippingNotice'));
});